import type { CatalogTree } from '../types';

// The dashboard (admin panel screens §3.2). The status labels of row 1 are the merchantStatus
// group of tr.ts but cancelled, which the spec names İptal on this screen.
export const dashboard = {
  title: 'Genel bakış',
  cancelled: 'İptal',
  mrr: 'MRR',
  arr: 'ARR',
  new: 'Yeni işletme',
  churned: 'Ayrılan işletme',
  failedPayments: 'Başarısız ödeme',
  revenue: 'Gelir (dönem)',
  ai: {
    title: 'Yapay zekâ maliyeti / gelir',
    units: 'Birim',
    tokensIn: 'Girdi token',
    tokensOut: 'Çıktı token',
    cost: 'Maliyet',
    noCost: 'Maliyet tahmini üretim sağlayıcısı seçilince eklenecek',
  },
  volume: {
    title: 'Konuşma hacmi',
    day: 'Gün',
    conversations: 'Konuşma',
  },
  handoffRate: 'Personele aktarma oranı',
  adapters: {
    title: 'Adaptör sağlığı',
    open: 'Adaptörler',
    errorRate: 'Hata oranı {rate}',
    expiring: 'Süresi dolacak kimlik bilgisi: {dates}',
  },
  openAlerts: 'Açık uyarılar',
  lastRun: {
    title: 'Son değerlendirme',
    open: 'Çalıştırmayı aç',
  },
} as const satisfies CatalogTree;
